import { post, get, postUrl, deleteApi, putJson, imagePost } from "./axios3";

const RESOURCE_BASE_PATH = "/public";
//

/***
 * 推广链接，会员中心URL修改
 * @param p
 */
export const updateMemberCenterURL = (p) =>
  get(`/decorationInfo/open/card`, p);

// 关闭会员中心URL
export const closeMemberCenterURL = (p) =>
  deleteApi(`${RESOURCE_BASE_PATH}/closeMemberCenterURL`, p);

//   查询会员中心URL状态
export const getMemberCenterURLStatus = (p) =>
  get(`/decorationInfo/open/card/status/get`, p);

